import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(value: any, type?: any, lang?: String): any {

    switch (lang) {
      case 'pl':
        return this.polishMonthTranslation(String(value), String(type));
      case 'eng':
        return this.englishMonthTranslation(String(value), String(type));
      default:
        return value;
    }
  }

  /**
   * Dodaje poprawiony odmieniony typ okresu
   * 
   * @private
   * @param {String} count 
   * @returns {String} 
   * 
   * @memberof DurationPipe
   */
  private polishMonthTranslation(count: String, type: String): String {
    let translations: Array<Object> = [
      {
        regex: /^0|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|20|21|25|26|27|28|29|30|31|35|36$/,
        translation: 'miesięcy'
      }, {
        regex: /^1$/,
        translation: 'miesiąc'
      }, {
        regex: /^2|3|4|22|23|24|32|33|34$/,
        translation: 'miesiące'
      }
    ];
    if (type === 'perpetual') {
      return 'bezterminowo';
    } else if (type === 'disposable') {
      return 'płatność jednorazowa';
    }

    for (let tranlation of translations) {
      if (tranlation['regex'].test(count)) {
        return count + ' ' + tranlation['translation'];
      }
    }
  }

  private englishMonthTranslation(count: String, type: String) {

  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/duration.pipe.ts